/**
 * Article Pull Quote Handler
 * Processes [pull-quote] blocks and converts them to styled blockquotes
 */

class ArticlePullQuote {
  constructor() {
    this.contentElement = document.querySelector('.article-template__content');
    
    if (!this.contentElement) return;
    
    this.init();
  }

  init() {
    this.processPullQuotes();
  }

  /**
   * Process [pull-quote] blocks in content
   */
  processPullQuotes() {
    const content = this.contentElement.innerHTML;
    
    // Find all [pull-quote]...[/pull-quote] blocks (case-insensitive, handles whitespace and attributes)
    // Matches: [pull-quote], [pull-quote data-cite-author="Name"], etc.
    const pullQuoteRegex = /\[pull-quote([^\]]*)\]([\s\S]*?)\[\/pull-quote\]/gi;
    const matches = [...content.matchAll(pullQuoteRegex)];
    
    if (matches.length === 0) return;

    let updatedContent = content;
    
    matches.forEach((match) => {
      const attributes = match[1].trim(); // Attributes string
      const quoteContent = match[2].trim(); // Content between tags
      const fullMatch = match[0];
      
      if (!quoteContent) {
        // If no content, remove the tags
        updatedContent = updatedContent.replace(fullMatch, '');
        return;
      }

      // Parse attributes (looking for data-cite-author)
      const citeAuthorMatch = attributes.match(/data-cite-author=["']([^"']+)["']/i);
      const citeAuthor = citeAuthorMatch ? citeAuthorMatch[1] : null;

      // Create blockquote element
      const blockquote = document.createElement('blockquote');
      blockquote.className = 'article-pull-quote';

      // Create temporary container to parse HTML content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = quoteContent;
      
      // Remove all empty <p> tags recursively (including those with only whitespace or <br> tags)
      const removeEmptyParagraphs = (element) => {
        const allParagraphs = element.querySelectorAll('p');
        
        // Iterate in reverse to avoid index issues when removing
        Array.from(allParagraphs).reverse().forEach((p) => {
          const textContent = p.textContent.trim();
          const innerHTML = p.innerHTML.trim();
          
          // Check if paragraph is empty (no text, or only <br> tags, or only whitespace)
          const hasOnlyBreaks = /^(<br\s*\/?>|\s)*$/i.test(innerHTML);
          
          if (!textContent || hasOnlyBreaks) {
            // Move any remaining content to parent before removing
            const parent = p.parentNode;
            while (p.firstChild) {
              parent.insertBefore(p.firstChild, p);
            }
            p.remove();
          }
        });
      };
      
      // Remove empty paragraphs
      removeEmptyParagraphs(tempDiv);
      
      // Unwrap any remaining <p> tags (extract their content)
      // This prevents nested <p> tags when we wrap in article-pull-quote__text
      const unwrapParagraphs = (element) => {
        const paragraphs = element.querySelectorAll('p');
        
        Array.from(paragraphs).reverse().forEach((p) => {
          const parent = p.parentNode;
          // Move all children of p to parent, then remove p
          while (p.firstChild) {
            parent.insertBefore(p.firstChild, p);
          }
          p.remove();
        });
      };
      
      unwrapParagraphs(tempDiv);
      
      // Remove inline styles from all elements (per user preference)
      const removeInlineStyles = (element) => {
        const allElements = element.querySelectorAll('*');
        allElements.forEach((el) => {
          if (el.hasAttribute('style')) {
            el.removeAttribute('style');
          }
        });
      };
      
      removeInlineStyles(tempDiv);
      
      // Get cleaned content (all <p> tags have been unwrapped)
      const cleanedContent = tempDiv.innerHTML.trim();
      
      // Skip if no content remains after cleaning
      if (!cleanedContent) {
        updatedContent = updatedContent.replace(fullMatch, '');
        return;
      }
      
      // Create paragraph for quote content with cleaned HTML
      const quoteParagraph = document.createElement('p');
      quoteParagraph.className = 'article-pull-quote__text';
      quoteParagraph.innerHTML = cleanedContent;
      
      // Final cleanup: remove any empty <p> tags that might have been created
      removeEmptyParagraphs(quoteParagraph);
      
      blockquote.appendChild(quoteParagraph);

      // Add cite if author is provided
      if (citeAuthor) {
        const cite = document.createElement('cite');
        cite.className = 'article-pull-quote__cite';
        cite.textContent = `— ${citeAuthor}`;
        blockquote.appendChild(cite);
      }

      // Replace the [pull-quote] block in the content
      updatedContent = updatedContent.replace(fullMatch, blockquote.outerHTML);
    });
    
    // Update content once with all replacements
    this.contentElement.innerHTML = updatedContent;
  }
}

// Initialize when DOM is ready
function initArticlePullQuote() {
  if (document.querySelector('.article-template__content')) {
    new ArticlePullQuote();
  } else {
    // Wait a bit and try again
    setTimeout(initArticlePullQuote, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initArticlePullQuote, 100);
  });
} else {
  setTimeout(initArticlePullQuote, 100);
}

